import { defineMessages } from 'react-intl-next';

export default defineMessages({
	continueFromLatestResponse: {
		id: 'fabric.editor.ai.config.item.action.continueFromLatestResponse',
		defaultMessage: 'Continue from last response',
		description: 'Move forward in history to the latest AI-generated content and prompt',
	},
});
